<script lang="ts" setup>
import recordUrl from '~ds/assets/illustrations/anyway-record.webp';
import { AlertDialog, AlertDialogContent, AlertDialogTitle } from '~ds/components/ui/alert-dialog';
import { Illustration } from '~ds/components/ui/illustration-system';
import { Spinner } from '~ds/components/ui/spinner';
import { textVariants } from '~ds/components/ui/typography';

const { t } = useI18n();
const { switchingAccount } = useSchoolsSignIn();

// Kept past a refused switch, so the loader names the school while it fades out.
const schoolName = ref('');
watch(switchingAccount, (switching) => {
  if (switching) {
    schoolName.value = switching.schoolName;
  }
}, { immediate: true });
</script>

<template>
  <AlertDialog :open="!!switchingAccount">
    <AlertDialogContent
      class="inset-0 z-80 flex max-w-none translate-x-0 translate-y-0 flex-col items-center justify-center gap-4 rounded-none border-0 p-0 shadow-none sm:max-w-none"
      :aria-describedby="undefined"
      data-testid="account-switcher-loader"
    >
      <Spinner size="xl">
        <Illustration
          :src="recordUrl"
          alt=""
          size="auto"
        />
      </Spinner>
      <div
        role="status"
        aria-live="polite"
        data-testid="account-switcher-loader-status"
      >
        <AlertDialogTitle class="text-muted-foreground" :class="textVariants({ size: 'sm', weight: 'normal' })">
          {{ t('schools.accountSwitcher.switching', { schoolName }) }}
        </AlertDialogTitle>
      </div>
    </AlertDialogContent>
  </AlertDialog>
</template>
